import { c as _c } from "react/compiler-runtime";
import LimitedText from '@/components/modules/LimitedText';
import Tooltip from '@/components/modules/Tooltip';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { InfoIcon } from '@winelidays/wld-tsx-2/images';
import { MealConfiguration } from '@winelidays/wld-tsx-2/modules';
const Description = t0 => {
    const $ = _c(16);
    const { descriptionTitle, description, mealConfiguration, className: t1 } = t0;
    const className = t1 === undefined ? "" : t1;
    const translate = useTranslate();
    let t2;
    if ($[0] !== mealConfiguration?.isExample || $[1] !== translate) {
        t2 = mealConfiguration?.isExample ? <Tooltip content={<p className="text-gray-400 font-semibold">{translate("meal_page.season_warning")}</p>}><button className="text-gray-300 ml-2 inline align-middle"><InfoIcon /></button></Tooltip> : null;
        $[0] = mealConfiguration?.isExample;
        $[1] = translate;
        $[2] = t2;
    }
    else {
        t2 = $[2];
    }
    const titleTooltip = t2;
    const t3 = `practicals-description flex flex-col w-full ${className}`;
    let t4;
    if ($[3] !== descriptionTitle || $[4] !== titleTooltip) {
        t4 = <h2 className="text-title mb-5">{descriptionTitle}{titleTooltip}</h2>;
        $[3] = descriptionTitle;
        $[4] = titleTooltip;
        $[5] = t4;
    }
    else {
        t4 = $[5];
    }
    let t5;
    if ($[6] !== mealConfiguration || $[7] !== translate) {
        t5 = !!mealConfiguration && <MealConfiguration formulas={mealConfiguration.formulas} drinks={mealConfiguration.drinks} translate={translate} className="mb-4"/>;
        $[6] = mealConfiguration;
        $[7] = translate;
        $[8] = t5;
    }
    else {
        t5 = $[8];
    }
    let t6;
    if ($[9] !== description) {
        t6 = description && <p className="w-full text-gray-400 font-semibold leading-7"><LimitedText text={description} maxRows={4} btnClassName="text-sm"/></p>;
        $[9] = description;
        $[10] = t6;
    }
    else {
        t6 = $[10];
    }
    let t7;
    if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
        t7 = <div className={t3}>{t4}{t5}{t6}</div>;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
        $[14] = t6;
        $[15] = t7;
    }
    else {
        t7 = $[15];
    }
    return t7;
};
export default Description;
